import React, { useState } from 'react';
import { FaSchool, FaHospital, FaMosque, FaWater, FaEdit, FaSave } from 'react-icons/fa';
import { MdTempleHindu } from "react-icons/md";
import { GiChurch, GiWaterDrop } from "react-icons/gi";

const GavatilSuvidhaMahiti = () => {
    const [isEditing, setIsEditing] = useState(false);
    
    const [data, setData] = useState({
        // Education
        schools: 0,
        colleges: 0,
        anganwadis: 0,
        
        // Health
        phc: false, // Primary Health Center
        clinics: 0,
        hospitals: 0,
        
        // Religious
        temples: 0,
        mosques: 0,
        churches: 0,
        otherReligious: 0,
        
        // Water
        wells: 0,
        borewells: 0,
        ponds: 0,
        dam: false,
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSave = () => {
        console.log("Saved Suvidha Data:", data);
        setIsEditing(false);
        alert('गावातील सुविधा माहिती यशस्वीरित्या सेव्ह केली!');
    };

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
            <div className="flex justify-between items-center mb-6 border-b pb-4">
                <h2 className="text-2xl font-bold text-[#267c77]">गावातील सुविधा माहिती</h2>
                <button
                    onClick={() => isEditing ? handleSave() : setIsEditing(true)}
                    className={`flex items-center space-x-2 px-6 py-2 rounded-lg font-medium transition-colors ${
                        isEditing 
                        ? 'bg-[#267c77] text-white hover:bg-[#1e635f]' 
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                    }`}
                >
                    {isEditing ? <FaSave /> : <FaEdit />}
                    <span>{isEditing ? 'माहिती सेव्ह करा' : 'माहिती अपडेट करा'}</span>
                </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                
                {/* Education Section */}
                <div className="bg-blue-50 p-6 rounded-xl border border-blue-100">
                    <div className="flex items-center text-blue-800 mb-4">
                        <FaSchool className="text-2xl mr-3" />
                        <h3 className="text-xl font-bold">शिक्षण (Education)</h3>
                    </div>
                    <div className="space-y-4">
                        <div className="flex justify-between items-center">
                            <label className="font-medium text-gray-700">शाळांची संख्या</label>
                            <input 
                                type="number" 
                                name="schools" 
                                value={data.schools} 
                                onChange={handleChange} 
                                disabled={!isEditing}
                                className="w-24 p-2 rounded border focus:ring-[#267c77] disabled:bg-gray-100"
                            />
                        </div>
                        <div className="flex justify-between items-center">
                            <label className="font-medium text-gray-700">कॉलेज संख्या</label>
                            <input 
                                type="number" 
                                name="colleges" 
                                value={data.colleges} 
                                onChange={handleChange} 
                                disabled={!isEditing}
                                className="w-24 p-2 rounded border focus:ring-[#267c77] disabled:bg-gray-100"
                            />
                        </div>
                        <div className="flex justify-between items-center">
                            <label className="font-medium text-gray-700">अंगणवाडी संख्या</label>
                            <input 
                                type="number" 
                                name="anganwadis" 
                                value={data.anganwadis} 
                                onChange={handleChange} 
                                disabled={!isEditing}
                                className="w-24 p-2 rounded border focus:ring-[#267c77] disabled:bg-gray-100"
                            />
                        </div>
                    </div>
                </div>

                {/* Health Section */}
                <div className="bg-red-50 p-6 rounded-xl border border-red-100">
                    <div className="flex items-center text-red-800 mb-4">
                        <FaHospital className="text-2xl mr-3" />
                        <h3 className="text-xl font-bold">आरोग्य (Health)</h3>
                    </div>
                    <div className="space-y-4">
                        <div className="flex justify-between items-center bg-white p-3 rounded-lg border border-red-100">
                            <label className="font-medium text-gray-700">प्राथमिक आरोग्य केंद्र (PHC)</label>
                            <div className="flex items-center">
                                <span className={`mr-2 text-sm font-bold ${data.phc ? 'text-green-600' : 'text-gray-400'}`}>
                                    {data.phc ? 'आहे' : 'नाही'}
                                </span>
                                <input 
                                    type="checkbox" 
                                    name="phc" 
                                    checked={data.phc} 
                                    onChange={handleChange} 
                                    disabled={!isEditing}
                                    className="w-5 h-5 text-[#267c77] focus:ring-[#267c77]"
                                />
                            </div>
                        </div>
                        <div className="flex justify-between items-center">
                            <label className="font-medium text-gray-700">क्लिनिक संख्या</label>
                            <input 
                                type="number" 
                                name="clinics" 
                                value={data.clinics} 
                                onChange={handleChange} 
                                disabled={!isEditing}
                                className="w-24 p-2 rounded border focus:ring-[#267c77] disabled:bg-gray-100"
                            />
                        </div>
                         <div className="flex justify-between items-center">
                            <label className="font-medium text-gray-700">हॉस्पिटल संख्या</label>
                            <input 
                                type="number" 
                                name="hospitals" 
                                value={data.hospitals} 
                                onChange={handleChange} 
                                disabled={!isEditing}
                                className="w-24 p-2 rounded border focus:ring-[#267c77] disabled:bg-gray-100"
                            />
                        </div>
                    </div>
                </div>

                {/* Religious Section */}
                <div className="bg-amber-50 p-6 rounded-xl border border-amber-100">
                    <div className="flex items-center text-amber-800 mb-4">
                        <MdTempleHindu className="text-2xl mr-3" />
                         <h3 className="text-xl font-bold">धार्मिक स्थळे (Religious)</h3>
                    </div>
                    <div className="space-y-4">
                        <div className="flex justify-between items-center">
                            <label className="font-medium text-gray-700">मंदिर संख्या</label>
                            <input 
                                type="number" 
                                name="temples" 
                                value={data.temples} 
                                onChange={handleChange} 
                                disabled={!isEditing}
                                className="w-24 p-2 rounded border focus:ring-[#267c77] disabled:bg-gray-100"
                            />
                        </div>
                        <div className="flex justify-between items-center">
                            <label className="font-medium text-gray-700">मशीद संख्या</label>
                             <input 
                                type="number" 
                                name="mosques" 
                                value={data.mosques} 
                                onChange={handleChange} 
                                disabled={!isEditing}
                                className="w-24 p-2 rounded border focus:ring-[#267c77] disabled:bg-gray-100"
                            />
                        </div>
                         <div className="flex justify-between items-center">
                            <label className="font-medium text-gray-700">चर्च संख्या</label>
                             <input 
                                type="number" 
                                name="churches" 
                                value={data.churches} 
                                onChange={handleChange} 
                                disabled={!isEditing}
                                className="w-24 p-2 rounded border focus:ring-[#267c77] disabled:bg-gray-100"
                            />
                        </div>
                        <div className="flex justify-between items-center">
                            <label className="font-medium text-gray-700">इतर धार्मिक स्थळे</label>
                             <input 
                                type="number" 
                                name="otherReligious" 
                                value={data.otherReligious} 
                                onChange={handleChange} 
                                disabled={!isEditing}
                                className="w-24 p-2 rounded border focus:ring-[#267c77] disabled:bg-gray-100"
                            />
                        </div>
                    </div>
                </div>

                 {/* Water Sources Section */}
                <div className="bg-cyan-50 p-6 rounded-xl border border-cyan-100">
                    <div className="flex items-center text-cyan-800 mb-4">
                        <GiWaterDrop className="text-2xl mr-3" />
                        <h3 className="text-xl font-bold">पाणी स्रोत (Water Sources)</h3>
                    </div>
                    <div className="space-y-4">
                        <div className="flex justify-between items-center">
                            <label className="font-medium text-gray-700">विहिरी संख्या</label>
                             <input 
                                type="number" 
                                name="wells" 
                                value={data.wells} 
                                onChange={handleChange} 
                                disabled={!isEditing}
                                className="w-24 p-2 rounded border focus:ring-[#267c77] disabled:bg-gray-100"
                            />
                        </div>
                        <div className="flex justify-between items-center">
                            <label className="font-medium text-gray-700">बोअरवेल संख्या</label>
                             <input 
                                type="number" 
                                name="borewells" 
                                value={data.borewells} 
                                onChange={handleChange} 
                                disabled={!isEditing}
                                className="w-24 p-2 rounded border focus:ring-[#267c77] disabled:bg-gray-100"
                            />
                        </div>
                         <div className="flex justify-between items-center">
                            <label className="font-medium text-gray-700">तलाव संख्या</label>
                             <input 
                                type="number" 
                                name="ponds" 
                                value={data.ponds} 
                                onChange={handleChange} 
                                disabled={!isEditing}
                                className="w-24 p-2 rounded border focus:ring-[#267c77] disabled:bg-gray-100"
                            />
                        </div>
                         <div className="flex justify-between items-center bg-white p-3 rounded-lg border border-cyan-100">
                            <label className="font-medium text-gray-700">धरण आहे का?</label>
                            <div className="flex items-center">
                                <span className={`mr-2 text-sm font-bold ${data.dam ? 'text-green-600' : 'text-gray-400'}`}>
                                    {data.dam ? 'आहे' : 'नाही'}
                                </span>
                                <input 
                                    type="checkbox" 
                                    name="dam" 
                                    checked={data.dam} 
                                    onChange={handleChange} 
                                    disabled={!isEditing}
                                    className="w-5 h-5 text-[#267c77] focus:ring-[#267c77]"
                                />
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default GavatilSuvidhaMahiti;
